// @react/hooks/useSubscriptionPlan.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { subscriptionPlanStore } from '@core/stores';

/**
 * React hook for SubscriptionPlan operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useSubscriptionPlan } from '@react/hooks';
 *
 * const SubscriptionPlanList = observer(() => {
 *   const store = useSubscriptionPlan();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useSubscriptionPlan() {
  return subscriptionPlanStore;
}
